import { useIntl } from '@zenbusiness/application-commons-intl';
import PageError from '@zenbusiness/zui/PageError';

import * as Routes from '#client/constants/routes';

const LoginError = () => {
  const { formatMessage } = useIntl();
  const loginUrl = `${window.location.origin}${Routes.login}`;

  return (
    <PageError
      subtitle={formatMessage({ id: 'dashboard.loginError.description' })}
      showBackButton
      slotProps={{
        backButton: {
          children: 'Back to login',
          href: `/oidc/logout?returnTo=${loginUrl}`,
        },
      }}
    />
  );
};

LoginError.propTypes = {};

export default LoginError;
